import { createReducer } from './utils';
import { BRANDS_SUCCESS, BRANDS_FAILURE, BRANDS_LOADING } from './constants';

const defaultState = {
  brandDict: {},
  loading: false,
  errorMessage: null,
};

// reducer

export const reducer = createReducer(defaultState, {
  [BRANDS_SUCCESS]: handleMesBrandsSuccess,
  [BRANDS_FAILURE]: handleMesBrandsFailure,
  [BRANDS_LOADING]: handleMesBrandsLoading,
});

//tasks report
function handleMesBrandsLoading(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function handleMesBrandsSuccess(state, { payload: { brandDict } }) {
  return {
    ...state,
    loading: false,
    brandDict: brandDict,
  };
}

function handleMesBrandsFailure(state, { payload: { error } }) {
  return {
    ...state,
    brandDict: {},
    loading: false,
    errorMessage: error,
  };
}

// actions

export function getAllBrands() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: BRANDS_LOADING });
    const {
      stores: { currentStore },
    } = getState();

    try {
      const brandDict = await dataSource.requestAllBrands({
        store: currentStore,
      });

      dispatch({ type: BRANDS_SUCCESS, payload: { brandDict } });
    } catch (error) {
      console.log('getAllBrands error', error);
      dispatch({ type: BRANDS_FAILURE, payload: { error } });
    }
  };
}
